module.exports = __webpack_public_path__ + "static/colgate-logo-b2f09b04e6bc9c851859201bc40888aa.png";